/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { RequestState } from '@shared/models/request-state';
import { KcmService } from './kcm.service';
import { KcmView } from './models/kcm.view';
import { AlertService } from '@shared/services/alert/alert.service';
import { DateTime } from 'luxon';
import { KcmResponse } from './models/kcm.response';

@Injectable({
  providedIn: 'root',
})
export class KcmStore {
  constructor(
    private kcmService: KcmService,
    private alertService: AlertService
  ) {}

  /** Load KCM data using cache strategy. */
  getKcm(airport: string): Observable<RequestState<KcmView>> {
    return this.kcmService.getKcm(airport).pipe(
      map((requestState) => {
        return this.mapResponse(requestState);
      })
    );
  }

  /** Force refresh of KCM data. */
  refreshKcm(airport: string): Observable<RequestState<KcmView>> {
    return this.kcmService.refreshKcm(airport).pipe(
      map((requestState) => {
        return this.mapResponse(requestState);
      })
    );
  }

  mapResponse(requestState: RequestState<KcmResponse>): RequestState<KcmView> {
    // TODO: Currently KCM endpoint returns 500 if no KCM data. Once this is changed to 404,
    // we can show error alert on error.
    // if (requestState.hasError) {
    //   this.showErrorAlert();
    // }
    if (!requestState.response) {
      return requestState.into<KcmView>();
    }

    const kcmView: KcmView = {
      timestamp: DateTime.fromISO(requestState.response.timestamp, {
        zone: 'utc',
      }),
      airport: requestState.response.airportId,
      mapUrl: requestState.response.mapUrl,
      lines: [],
    };

    const lines = requestState.response.description.split('\n').map((line) => {
      const parts = line.split(':', 2);
      if (parts.length === 2) {
        return {
          label: parts[0],
          description: parts[1],
        };
      }

      return {
        label: '',
        description: line,
      };
    });

    kcmView.lines = lines;
    return requestState.into<KcmView>(kcmView);
  }

  private showErrorAlert(): void {
    this.alertService.setAlert({
      type: 'error',
      message: 'Failed to load KCM data.',
    });
  }
}
